import { RouteRecordRaw } from 'vue-router';

export const isDashboardNewRoute = () => window.location.pathname.startsWith('/dashboard-new');

export const routeToMenu = (routes: RouteRecordRaw[]) => {
  const toReturn: any = [];

  for (const idx in routes) {
    const route = routes[idx];
    const toAdd: any = {
      ...route.meta,
      name: route.name,
    };

    if (route.meta?.href) {
      toAdd.href = route.meta?.href;
    } else {
      toAdd.to = { name: route.name };
    }

    toReturn.push(toAdd);
  }

  return toReturn;
};
